/**
 * /frontend/src/features/analytics/components/queue/WaitTimeTrendChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import TrendLineChart from '../charts/TrendLineChart';
import { CHART_COLORS } from '../../constants/chartColors';
import { toQueueWaitTrendSeries } from '../../utils/chartDataTransformers';
import { formatMinutes } from '../../utils/formatters';

/**
 * Wait time trend chart (avg vs median).
 * @param {{trend:any}} props
 * @returns {JSX.Element}
 */
const WaitTimeTrendChart = ({ trend }) => {
  const data = useMemo(() => toQueueWaitTrendSeries(trend), [trend]);
  const lines = useMemo(() => ([
    { key: 'avgWaitMinutes', label: 'Avg wait (min)', color: CHART_COLORS.accent },
    { key: 'medianWaitMinutes', label: 'Median wait (min)', color: CHART_COLORS.accentStrong }
  ]), []);

  return (
    <ChartContainer title="Wait Time Trend" subtitle="Average vs median wait time">
      <TrendLineChart data={data} xKey="label" lines={lines} yFormatter={(v) => formatMinutes(v)} />
    </ChartContainer>
  );
};

export default WaitTimeTrendChart;

